module.exports = __webpack_public_path__ + "static/pexels-cottonbro-4039184-7a9d42645e013f836046e90d0dc9e015.jpg";